export default __webpack_public_path__ + "static/media/graph-title.17c29c52.png";